import { Type } from "class-transformer";
import { observable } from "mobx";
import "reflect-metadata";
import NotificationPreferences from "./notificationPreferences";

export default class ChargeOrderContactItem {
  @Type(() => NotificationPreferences)
  @observable
  notificationPreferences: NotificationPreferences;

  constructor(notificationPreferences: NotificationPreferences) {
    this.notificationPreferences = notificationPreferences;
  }
}
